/* eslint-disable angular/document-service */
/* eslint-disable angular/window-service */
let controller = new AbortController();
let signal = controller.signal;
export const fetchAIPrompt = async (inputValue) => {
    const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = csrfMetaTag ? csrfMetaTag.getAttribute('content') : null;
    try {
        window.dispatchEvent(new CustomEvent('processingStateChanged', { detail: { isProcessing: true } }));
        const response = await fetch('/api/evertrue/ai/completions', {
            signal: signal,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({ prompt: inputValue }),
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        window.dispatchEvent(new CustomEvent('processingStateChanged', { detail: { isProcessing: false, isError: false } }));
        return data;
    } catch (error) {
        if (error.name === 'AbortError') {
            // Aborting fetch triggered by user with the cancel button
            console.log('Canceled the AI Prompt Request');
            const emailContainer = document.getElementsByClassName('tv-rich-text-content');
            if (emailContainer[0]) {
                emailContainer[0].innerHTML = '';
            }

            // reset controller to recall the fetch request
            controller = new AbortController();
            signal = controller.signal;
        } else {
            console.error('Error fetching data:', error);
        }
        window.dispatchEvent(new CustomEvent('processingStateChanged', { detail: { isProcessing: false, isError: true } }));
        throw error;
    }
};

export const handleAIPromptFetch = async (input) => {
    try {
        const response = await fetchAIPrompt(input);
        const emailContainer = document.getElementsByClassName('tv-rich-text-content');
        if (response && response.data && emailContainer[0]) {
            emailContainer[0].innerHTML = response.data.replace(/\n/g, '<br>');
        }
    } catch (error) {
        if (error.name !== 'AbortError') {
            console.error('Failed to fetch user data:', error);
        }
        throw error;
    }
};

export const handleCancelAiPrompt = async () => {
    try {
        controller.abort();
    } catch (error) {
        console.error('Error canceling the prompt: ', error);
    }
};
